import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-access-view',
  templateUrl: './request-access-view.component.html',
  styleUrls: ['./request-access-view.component.scss']
})
export class RequestAccessViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
